'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import NavMarker from 'react-rhumb/NavMarker';
import Immutable from 'immutable';
import I18n from 'I18n';
import * as GoodTypes from 'marketplace-lib/constants/GoodTypes';
import * as GoodSubTypes from 'marketplace-lib/constants/GoodSubTypes';
import * as GoodsActions from '../actions/GoodsActions';
import * as TrialStateActions from '../actions/TrialStateActions';
import GoodSubTypeGroups from '../constants/GoodSubTypeGroups';
import HeaderTabs from '../constants/HeaderTabs';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import * as authSelectors from '../selectors/auth';
import { getCanReview } from '../selectors/goodDetails';
import { getIsReviewModalOpen } from '../selectors/reviewInputInfo';
import { getCanTrial } from '../selectors/trialState';
import { getSubTypesFromPackCounts } from '../utils/utils';
import AppHeader from '../components/AppHeader';
import DashboardPage from '../components/layout/DashboardPage';
import GoodDetailsPage from '../components/goodDetails/GoodDetailsPage';
import LoadingWrapper from '../components/LoadingWrapper';
import SearchBarContainer from './SearchBarContainer';
import { Screens } from '../lib/usage/constants';
import withUsageTracking from './hocs/withUsageTracking';
import LoadingErrorPage from '../components/LoadingErrorPage';
var closeReviewModal = GoodsActions.closeReviewModal,
    onClickPurchaseErrorModalClose = GoodsActions.onClickPurchaseErrorModalClose,
    triggerReviewModal = GoodsActions.triggerReviewModal;

var LoadingErrorComponent = function LoadingErrorComponent() {
  return React.createElement(NavMarker, {
    name: "DETAIL_ERROR_LOAD"
  }, React.createElement(LoadingErrorPage, null));
};

var GoodDetailsContainer = /*#__PURE__*/function (_Component) {
  _inherits(GoodDetailsContainer, _Component);

  function GoodDetailsContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GoodDetailsContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GoodDetailsContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.setDocumentTitle = function () {
      document.title = I18n.text('MarketplaceUI.goodDetailsPage.documentTitle', {
        name: _this.props.goodDetails.get('goodName')
      });
    };

    _this.handleNavigateFromGoodDetailsReview = function () {
      var _this$props = _this.props,
          navigateFromGoodDetailsReview = _this$props.navigateFromGoodDetailsReview,
          routeParams = _this$props.routeParams;
      var goodNameUrlToken = routeParams.goodNameUrlToken,
          providerUrlToken = routeParams.providerUrlToken;
      navigateFromGoodDetailsReview(providerUrlToken, goodNameUrlToken);
    };

    _this.trackDetailsPageLinkClick = function (itemClicked) {
      _this.props.trackClickedLink(Screens.DETAILS, itemClicked);
    };

    _this.renderAppHeader = function () {
      var categoryFilter = 'all-products';

      if (_this.props.isTemplate || _this.props.isPack || _this.props.isEmailTemplate) {
        categoryFilter = GoodSubTypeGroups.TEMPLATES;
      } else if (_this.props.isCustomModule) {
        categoryFilter = GoodTypes.CUSTOM_MODULE;
      }

      return React.createElement(AppHeader, {
        currentTab: HeaderTabs.STOREFRONT,
        searchBarComponent: React.createElement(SearchBarContainer, {
          screen: "details",
          categoryFilter: categoryFilter
        })
      });
    };

    return _this;
  }

  _createClass(GoodDetailsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          getGoodDetails = _this$props2.getGoodDetails,
          getTrialState = _this$props2.getTrialState,
          isCustomer = _this$props2.isCustomer,
          previewMode = _this$props2.previewMode,
          routeParams = _this$props2.routeParams,
          trackPageview = _this$props2.trackPageview;
      trackPageview(Screens.DETAILS);
      var provider = routeParams.providerUrlToken;
      getGoodDetails(provider, routeParams.goodNameUrlToken, previewMode, isCustomer);

      if (isCustomer) {
        getTrialState();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          goodDetails = _this$props3.goodDetails,
          getGoodDetails = _this$props3.getGoodDetails,
          isCustomer = _this$props3.isCustomer,
          reviewModalOpen = _this$props3.reviewModalOpen,
          _this$props3$routePar = _this$props3.routeParams,
          providerUrlToken = _this$props3$routePar.providerUrlToken,
          goodNameUrlToken = _this$props3$routePar.goodNameUrlToken;
      var prevGoodDetails = prevProps.goodDetails,
          prevReviewModalOpen = prevProps.reviewModalOpen,
          _prevProps$routeParam = prevProps.routeParams,
          prevProviderUrlToken = _prevProps$routeParam.providerUrlToken,
          prevGoodNameUrlToken = _prevProps$routeParam.goodNameUrlToken;

      if (prevGoodDetails.get('requestStatus') === RequestStatusTypes.PENDING && goodDetails.get('requestStatus') === RequestStatusTypes.SUCCEEDED) {
        this.setDocumentTitle();
      }

      if (providerUrlToken !== prevProviderUrlToken || goodNameUrlToken !== prevGoodNameUrlToken) {
        getGoodDetails(providerUrlToken, goodNameUrlToken, false, isCustomer);
      }

      if (prevReviewModalOpen && !reviewModalOpen) {
        this.handleNavigateFromGoodDetailsReview();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetGoodDetails();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          auth = _this$props4.auth,
          canReview = _this$props4.canReview,
          canTrialMarketing = _this$props4.canTrialMarketing,
          goodDetails = _this$props4.goodDetails,
          goodFiltersAndPage = _this$props4.goodFiltersAndPage,
          hasPurchaseAccess = _this$props4.hasPurchaseAccess,
          isCustomModule = _this$props4.isCustomModule,
          isCustomer = _this$props4.isCustomer,
          isEmailTemplate = _this$props4.isEmailTemplate,
          isPack = _this$props4.isPack,
          isTemplate = _this$props4.isTemplate,
          isTheme = _this$props4.isTheme,
          location = _this$props4.location,
          previewMode = _this$props4.previewMode,
          reviewMode = _this$props4.reviewMode,
          routeParams = _this$props4.routeParams;
      return React.createElement(DashboardPage, {
        headerComponent: !previewMode && this.renderAppHeader(),
        pageLayout: "full-width",
        "data-selenium-selector": "good-details-container"
      }, React.createElement(LoadingWrapper, {
        ErrorComponent: LoadingErrorComponent,
        requestStatus: goodDetails.get('requestStatus')
      }, React.createElement(GoodDetailsPage, {
        auth: auth,
        canReview: canReview,
        canTrialMarketing: canTrialMarketing,
        closeReviewModal: this.props.closeReviewModal,
        goodFiltersAndPage: goodFiltersAndPage,
        goodNameUrlToken: routeParams.goodNameUrlToken,
        hasPurchaseAccess: hasPurchaseAccess,
        isCustomModule: isCustomModule,
        isCustomer: isCustomer,
        isEmailTemplate: isEmailTemplate,
        isPack: isPack,
        isTemplate: isTemplate,
        isTheme: isTheme,
        navigateFromGoodDetailsReview: this.handleNavigateFromGoodDetailsReview,
        onClickPurchaseErrorModalClose: this.props.onClickPurchaseErrorModalClose,
        packChildrenSubTypes: getSubTypesFromPackCounts(goodDetails.get('packCounts')),
        previewMode: previewMode,
        reviewMode: reviewMode,
        redirectUrl: location.query.redirectUrl,
        goodDetails: goodDetails,
        providerUrlToken: routeParams.providerUrlToken,
        trackLinkClick: this.trackDetailsPageLinkClick,
        triggerReviewModal: this.props.triggerReviewModal
      })));
    }
  }]);

  return GoodDetailsContainer;
}(Component);

GoodDetailsContainer.propTypes = {
  auth: PropTypes.object.isRequired,
  canReview: PropTypes.bool.isRequired,
  canTrialMarketing: PropTypes.bool.isRequired,
  closeReviewModal: PropTypes.func.isRequired,
  getGoodDetails: PropTypes.func.isRequired,
  getTrialState: PropTypes.func.isRequired,
  goodDetails: PropTypes.object.isRequired,
  goodFiltersAndPage: PropTypes.instanceOf(Immutable.Map).isRequired,
  hasPurchaseAccess: PropTypes.bool.isRequired,
  isCustomModule: PropTypes.bool.isRequired,
  isCustomer: PropTypes.bool.isRequired,
  isEmailTemplate: PropTypes.bool.isRequired,
  isPack: PropTypes.bool.isRequired,
  isTemplate: PropTypes.bool.isRequired,
  isTheme: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  navigateFromGoodDetailsReview: PropTypes.func.isRequired,
  onClickPurchaseErrorModalClose: PropTypes.func.isRequired,
  previewMode: PropTypes.bool,
  resetGoodDetails: PropTypes.func.isRequired,
  reviewModalOpen: PropTypes.bool,
  reviewMode: PropTypes.bool,
  routeParams: PropTypes.shape({
    goodNameUrlToken: PropTypes.string.isRequired,
    providerUrlToken: PropTypes.string.isRequired
  }).isRequired,
  trackClickedLink: PropTypes.func.isRequired,
  trackPageview: PropTypes.func.isRequired,
  triggerReviewModal: PropTypes.func.isRequired
};
GoodDetailsContainer.defaultProps = {
  previewMode: false,
  reviewMode: false
};

function mapStateToProps(state) {
  var goodDetails = state.goodDetails;
  var goodSubType = goodDetails.get('subType');
  var goodType = goodDetails.get('type');
  var isTemplate = goodType === GoodTypes.COS_TEMPLATE;
  return {
    auth: state.auth,
    canReview: getCanReview(state),
    canTrialMarketing: getCanTrial(state, 'marketing-pro'),
    goodDetails: goodDetails,
    goodFiltersAndPage: state.directoryData.get('goodFiltersAndPage'),
    hasPurchaseAccess: authSelectors.getHasInstallAccess(state),
    isCustomModule: goodType === GoodTypes.CUSTOM_MODULE,
    isCustomer: authSelectors.getIsCustomer(state),
    isEmailTemplate: isTemplate && goodSubType === GoodSubTypes.EMAIL_TEMPLATES,
    isPack: goodType === GoodTypes.PACK,
    isTemplate: isTemplate,
    isTheme: goodType === GoodTypes.CMS_THEME,
    reviewModalOpen: getIsReviewModalOpen(state)
  };
}

var mapDispatchToProps = {
  closeReviewModal: closeReviewModal,
  getGoodDetails: GoodsActions.getGoodDetails,
  getTrialState: TrialStateActions.fetchTrialState,
  navigateFromGoodDetailsReview: GoodsActions.navigateFromGoodDetailsReview,
  onClickPurchaseErrorModalClose: onClickPurchaseErrorModalClose,
  resetGoodDetails: GoodsActions.resetGoodDetails,
  triggerReviewModal: triggerReviewModal
};
export default compose(withUsageTracking(), connect(mapStateToProps, mapDispatchToProps))(GoodDetailsContainer);